import React from "react";

/**
 * Activity progress row.
 * Props:
 * - label: string
 * - percent: number
 * - areas?: string[]
 */
export default function ActivityProgressBar({ label, percent = 0, areas }) {
  const pct = Math.max(0, Math.min(100, percent));

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between gap-3 text-sm mb-2">
        <div className="font-medium text-gray-900 truncate">{label}</div>
        <div className="text-gray-600 tabular-nums">{pct}%</div>
      </div>

      {/* progress track */}
      <div
        className="relative h-2.5 rounded-full bg-gray-100 overflow-hidden"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={`${label} progress`}
      >
        <div
          className="h-full bg-teal-500"
          style={{
            width: `${pct}%`,
            backgroundImage:
              "linear-gradient(90deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0) 30%)",
          }}
        />
        {/* milestone dot at 100% */}
        {pct === 100 ? (
          <span className="absolute right-0 -mr-1 -mt-1 top-1/2 h-3 w-3 rounded-full bg-teal-500 ring-2 ring-white" />
        ) : null}
      </div>

      {areas?.length ? (
        <div className="text-xs text-gray-500 mt-1 truncate">
          Areas: {areas.join(", ")}
        </div>
      ) : null}
    </div>
  );
}
